module.exports = __webpack_public_path__ + "static/img/07.1c5fae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/07.png
// module id = bR9O
// module chunks = 2